import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { NavigationService } from '@services/nav/nav.service';
import { BusinessFeatureFlagSelectors, BusinessState } from '@state/business';
import { filter, switchMap, tap } from 'rxjs/operators';

// Delete this file once the feature is completely out.
export const sc16163EnableSignItGuard: CanMatchFn = () => {
	const navService = inject(NavigationService);
	const store = inject(Store);
	return store.select(BusinessState.getLoaded).pipe(
		filter((loaded) => loaded),
		switchMap(() =>
			store.select(BusinessFeatureFlagSelectors.sc16163EnableSignIt),
		),
		tap(
			(isSignItEnabled) =>
				!isSignItEnabled && navService.goToProfile_Integrations(),
		),
	);
};
